var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime.js");

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.getOrientation = {}));
})(this, function (exports) {
  'use strict';
  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0
    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.
    See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }

      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }

      function step(result) {
        result.done ? resolve(result.value) : new P(function (resolve) {
          resolve(result.value);
        }).then(fulfilled, rejected);
      }

      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  }

  (function (Orientation) {
    Orientation[Orientation["TOP_LEFT"] = 1] = "TOP_LEFT";
    Orientation[Orientation["TOP_RIGHT"] = 2] = "TOP_RIGHT";
    Orientation[Orientation["BOTTOM_RIGHT"] = 3] = "BOTTOM_RIGHT";
    Orientation[Orientation["BOTTOM_LEFT"] = 4] = "BOTTOM_LEFT";
    Orientation[Orientation["LEFT_TOP"] = 5] = "LEFT_TOP";
    Orientation[Orientation["RIGHT_TOP"] = 6] = "RIGHT_TOP";
    Orientation[Orientation["RIGHT_BOTTOM"] = 7] = "RIGHT_BOTTOM";
    Orientation[Orientation["LEFT_BOTTOM"] = 8] = "LEFT_BOTTOM";
  })(exports.Orientation || (exports.Orientation = {}));

  var fileReaderMap = new WeakMap();

  function getOrientation(input) {
    return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offset, totalBytes, bufSignature, signature, head, tail, bufMarker, marker, bufSegmentHead, segmentHead, isEXIF, segmentSize, bufSegmentSize, _segmentSize, remainingBytes, bufTIFFHeader, tiffHeader, isLittleEndian, ifdOffset, bufFieldCount, fieldCount, bufField, field, tagId, value;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (input instanceof ArrayBuffer || input instanceof Blob) {
                _context.next = 2;
                break;
              }

              throw new TypeError("Unexpected input type");

            case 2:
              offset = 0;
              totalBytes = getSize(input); // Signature validation

              _context.next = 6;
              return readBytes(input, offset, 4);

            case 6:
              bufSignature = _context.sent;
              offset += bufSignature.byteLength;
              signature = new DataView(bufSignature);
              head = signature.getUint16(0);
              tail = signature.getUint16(2); // Check EXIF SOI first

              if (!(head === 0xffd8)) {
                _context.next = 47;
                break;
              }

              // This is EXIF structure. handle application markers
              bufMarker = bufSignature.slice(2);

            case 13:
              marker = new DataView(bufMarker).getUint16(0);

              if (!(marker === 0xffe1)) {
                _context.next = 29;
                break;
              }

              _context.next = 17;
              return readBytes(input, offset, 8);

            case 17:
              bufSegmentHead = _context.sent;
              segmentHead = new DataView(bufSegmentHead);
              isEXIF = segmentHead.getUint16(2) === 0x4578 && segmentHead.getUint16(4) === 0x6966 && segmentHead.getUint16(6) === 0x0000;

              if (!isEXIF) {
                _context.next = 25;
                break;
              }

              offset += bufSegmentHead.byteLength;
              return _context.abrupt("break", 45);

            case 25:
              segmentSize = segmentHead.getUint16(0);
              offset += segmentSize;

            case 27:
              _context.next = 40;
              break;

            case 29:
              if (!(0xffe0 <= marker && marker <= 0xffef)) {
                _context.next = 39;
                break;
              }

              _context.next = 32;
              return readBytes(input, offset, 2);

            case 32:
              bufSegmentSize = _context.sent;
              offset += bufSegmentSize.byteLength;
              _segmentSize = new DataView(bufSegmentSize).getUint16(0);
              remainingBytes = _segmentSize - 2;
              offset += remainingBytes;
              _context.next = 40;
              break;

            case 39:
              return _context.abrupt("return", exports.Orientation.TOP_LEFT);

            case 40:
              _context.next = 42;
              return readBytes(input, offset, 2);

            case 42:
              bufMarker = _context.sent;
              offset += bufMarker.byteLength;

            case 44:
              if (offset < totalBytes) {
                _context.next = 13;
                break;
              }

            case 45:
              _context.next = 52;
              break;

            case 47:
              if (!(head === 0x4949 && tail === 0x2a00 || head === 0x4d4d && tail === 0x002a)) {
                _context.next = 51;
                break;
              }

              // yeah this is TIFF header
              // reset offset cursor.
              offset = 0;
              _context.next = 52;
              break;

            case 51:
              return _context.abrupt("return", exports.Orientation.TOP_LEFT);

            case 52:
              _context.next = 54;
              return readBytes(input, offset, 8);

            case 54:
              bufTIFFHeader = _context.sent;
              tiffHeader = new DataView(bufTIFFHeader);
              isLittleEndian = tiffHeader.getUint16(0) === 0x4949;
              ifdOffset = tiffHeader.getUint32(4, isLittleEndian); // move cursor to IFD block

              offset += ifdOffset;
              _context.next = 61;
              return readBytes(input, offset, 2);

            case 61:
              bufFieldCount = _context.sent;
              offset += bufFieldCount.byteLength;
              fieldCount = new DataView(bufFieldCount).getUint16(0, isLittleEndian);

            case 64:
              if (!(fieldCount-- > 0)) {
                _context.next = 80;
                break;
              }

              _context.next = 67;
              return readBytes(input, offset, 12);

            case 67:
              bufField = _context.sent;
              offset += bufField.byteLength;
              field = new DataView(bufField);
              tagId = field.getUint16(0, isLittleEndian);

              if (!(tagId === 0x112)) {
                _context.next = 78;
                break;
              }

              // Orientation Tag
              value = new DataView(bufField.slice(8, 12)).getUint16(0, isLittleEndian);

              if (!(1 <= value && value <= 8)) {
                _context.next = 77;
                break;
              }

              return _context.abrupt("return", value);

            case 77:
              throw new Error("Unexpected Orientation Value");

            case 78:
              _context.next = 64;
              break;

            case 80:
              return _context.abrupt("return", exports.Orientation.TOP_LEFT);

            case 81:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }

  function readBytes(input, offset, size) {
    if (input instanceof Blob) {
      return new Promise(function (resolve, reject) {
        var reader = fileReaderMap.get(input);

        if (!reader) {
          reader = new FileReader();
          fileReaderMap.set(input, reader);
        }

        reader.onerror = function (e) {
          reader.onerror = null;
          reader.onload = null;
          reject(e);
        };

        reader.onload = function () {
          reader.onerror = null;
          reader.onload = null;
          resolve(reader.result);
        };

        reader.readAsArrayBuffer(input.slice(offset, offset + size));
      });
    }

    return Promise.resolve(input.slice(offset, offset + size));
  }

  function getSize(input) {
    return input instanceof Blob ? input.size : input.byteLength;
  }

  exports.getOrientation = getOrientation;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});